import { bookmarkStore } from './stores'

// init 은 저장소가 깨져 있어도 앱이 뜨게 한다. 이 호출은 모듈 최상위라
// 여기서 예외가 나가면 번들 평가가 끊겨 화면 전체가 백지가 된다.
export function init() {
  const raw = window.localStorage.getItem('bookmarks')
  if (!raw) {
    return
  }
  let parsed
  try {
    parsed = JSON.parse(raw)
  } catch (e) {
    console.error('다시보기 목록을 읽지 못했습니다:', e)
    return
  }
  if (!Array.isArray(parsed)) {
    console.error('다시보기 목록이 배열이 아닙니다')
    return
  }
  // url 없는 항목은 담기·빼기의 키가 없어 목록에 남으면 지울 수 없다.
  parsed.filter(post => post && post.url).forEach(bookmarkStore.add)
}

export function add(post) {
  save([...bookmarkStore.posts, post])
  bookmarkStore.add(post)
}

export function del(post) {
  const index = getIndex(post)
  if (index < 0) {
    return
  }
  const next = bookmarkStore.posts.slice()
  next.splice(index, 1)
  save(next)
  bookmarkStore.del(index)
}

// getIndex 는 url (글 자연 키) 로 북마크 여부를 판단한다.
// id (auto PK) 는 DB 재적재로 흔들려 부적합 — export/import·화면 토글 모두 url 로 통일한다.
export function getIndex(post) {
  return bookmarkStore.posts.findIndex(({ url }) => url === post.url)
}

export function has(post) {
  return 0 <= getIndex(post)
}

export function reverse() {
  console.log('all:', bookmarkStore.posts)
  return bookmarkStore.posts.reverse()
}

export function count() {
  return bookmarkStore.posts.length
}

// clear 는 다시보기 목록을 통째로 비운다 (되돌릴 수 없음 — 호출부에서 확인 후 호출).
export function clear() {
  save([])
  bookmarkStore.clear()
}

// list 는 최신 글이 위로 오도록 뒤집은 표시용 목록을 반환한다 (원본 posts 비파괴 — in-place 인 reverse 와 다름).
export function list() {
  return bookmarkStore.posts.slice().reverse()
}

// exportText 는 다시보기 목록을 다른 기기로 옮길 수 있게 JSON 문자열로 직렬화한다.
// 화면 렌더에 쓰는 3필드만 담는다 — 불안정한 id·표시에 안 쓰는 hit·post_time 은 다른 기기로 실어 나르지 않는다.
export function exportText() {
  const slim = bookmarkStore.posts.map(({ publisher, url, subject }) => ({ publisher, url, subject }))
  return JSON.stringify(slim)
}

// importText 는 내보낸 JSON 을 파싱해 기존 목록과 병합한다.
// 중복 판단은 url (글 자연 키) 기준 — DB 재적재로 id (auto PK) 가 바뀌어도 흔들리지 않는다.
// 파싱 실패는 조용히 삼키지 않고 에러로 표면화. 추가된 개수를 반환한다.
export function importText(text) {
  let parsed
  try {
    parsed = JSON.parse(text)
  } catch (e) {
    throw new Error('JSON 형식이 아닙니다')
  }
  if (!Array.isArray(parsed)) {
    throw new Error('다시보기 목록 (배열) 형식이 아닙니다')
  }
  const existingUrls = new Set(bookmarkStore.posts.map(p => p.url))
  const toAdd = []
  // 파일의 위→아래 순서를 화면 위→아래로 보존한다. list() 가 reverse (최근 북마크가 위) 하므로
  // 역순으로 add 해야 파일 첫 항목이 화면 맨 위로 온다.
  for (let i = parsed.length - 1; 0 <= i; i--) {
    const post = parsed[i]
    if (!post || !post.url || existingUrls.has(post.url)) {
      continue
    }
    toAdd.push(post)
    existingUrls.add(post.url)
  }
  if (0 < toAdd.length) {
    save([...bookmarkStore.posts, ...toAdd])
    toAdd.forEach(bookmarkStore.add)
  }
  return toAdd.length
}

// save 는 저장이 성공한 뒤에야 호출부가 store 를 바꾸도록 먼저 쓴다.
// store 를 먼저 바꾸면 저장이 실패했을 때 화면에는 담긴 것으로 보이는데 새로고침하면
// 사라진다. 실패는 그대로 던져 호출부가 사용자에게 알린다.
function save(posts) {
  window.localStorage.setItem('bookmarks', JSON.stringify(posts))
}

init()